import { Box, Typography, useTheme, useMediaQuery, IconButton, Button, Alert, Chip } from "@mui/material";
import {
    ConnectedTv,
    PixOutlined,
    PostAddOutlined,
    TollOutlined,
    Translate,
    NewReleases,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import top_pcguy from "../../assets/landing/top_pcguy.png";

const Top = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    const dark = theme.palette.neutral.dark;
    const primaryLight = theme.palette.primary.light;
    return (
        <Box
            width="100%"
            padding="2rem 6%"
            display={isNonMobileScreens ? "flex" : "block"}
            gap="2rem"
            justifyContent="center"
        >
   
            <Box flexBasis={isNonMobileScreens ? "45%" : undefined}>
                <Box
                    display="flex"
                    flexDirection="column"
                    gap="1rem"
                    justifyContent="center"
                    height="100%"
                    width="100%"
                >
                    <Typography
                        component="h1"
                        fontWeight="bold"
                        fontSize="clamp(1rem, 2rem, 2.25rem)"
                        color="white"
                    >
                        Master Anything with Uben
                    </Typography>
                    <Typography
                        fontSize="clamp(1rem, 1rem, 1.25rem)"
                        color="#484a4c"
                    >
                        The ultimate spaced repetition platform for learning any subject.
                    </Typography>
                    <Typography
                        fontSize="clamp(0.9rem, 1rem, 1.1rem)"
                        color="#484a4c"
                        sx={{ mt: 1 }}
                    >
                        From languages and sciences to art, trivia, coding, and beyond - create custom decks for absolutely anything you want to learn.
                    </Typography>
                    {/* Get Started Button - Mobile Only */}
                    {!isNonMobileScreens && (
                        <Box
                            display="flex"
                            gap="1rem"
                            justifyContent="center"
                            width="100%"
                            mt={2}
                            flexDirection="column"
                        >
                            <Button 
                                variant="outlined"
                                size="large"
                                onClick={() => navigate("/login")}
                                sx={{
                                    color: "black",
                                    borderColor: "black",
                                    fontSize: "1.1rem",
                                    fontWeight: "600",
                                    py: 1.5,
                                    px: 4,
                                    borderRadius: "10px",
                                    textTransform: "none",
                                    minWidth: "180px",
                                    borderWidth: "2px",
                                    "&:hover": {
                                        backgroundColor: "black",
                                        color: "white",
                                        borderColor: "black",
                                    },
                                    transition: "all 0.2s ease-in-out"
                                }}
                            >
                                Login
                            </Button>
                            <Button 
                                variant="contained"
                                size="large"
                                onClick={() => window.open("https://discord.gg/JtcrpG7ECA", "_blank")}
                                sx={{
                                    backgroundColor: "#5865F2",
                                    color: "white",
                                    fontSize: "1.1rem",
                                    fontWeight: "600",
                                    py: 1.5,
                                    px: 4,
                                    borderRadius: "10px",
                                    textTransform: "none",
                                    minWidth: "180px",
                                    "&:hover": {
                                        backgroundColor: "#4752C4",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 4px 12px rgba(88, 101, 242, 0.4)",
                                    },
                                    transition: "all 0.2s ease-in-out"
                                }}
                            >
                                Join Community
                            </Button>
                        </Box>
                    )}
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="0.5rem"
                        justifyContent="left"
                        alignItems="center"
                        mt="2rem"
                        onClick={() => navigate("/login")}
                        sx={{
                            background: "rgba(0,0,0,0.0)",
                            borderRadius: "1rem",
                            padding: "1rem",
                            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                            width: "80%",

                            "&:hover": {
                                cursor: "pointer",
                                background: "rgba(0,0,0,0.05)",
                                transition: "all 0.2s ease-in-out",
                            },

                        }}
                    >
                        <IconButton
                            sx={{
                                color: "black",
                                fontSize: "clamp(1rem, 1rem, 1.25rem)",
                            }}
                        >
                            <Translate sx={{ fontSize: "25px" }} />
                        </IconButton>
                        <Box display="flex" flexDirection="column" gap="0.5rem">
                            <Typography
                                fontWeight="bold"
                                fontSize="clamp(1rem, 1rem, 1.25rem)"
                                color="white"
                            >
                                Languages
                            </Typography>
                            <Typography
                                fontSize="clamp(0.8rem, 0.9rem, 1rem)"
                                color="#484a4c"
                            >
                                Arabic, Chinese, English, French, German, Hebrew, Japanese, Korean, Russian, Spanish, and more!
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap="0.5rem"
                        justifyContent="left"
                        alignItems="center"
                        onClick={() => navigate("/login")}
                        sx={{
                            background: "rgba(0,0,0,0.0)",
                            borderRadius: "1rem",
                            padding: "1rem",
                            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                            width: "80%",

                            "&:hover": {
                                cursor: "pointer",
                                background: "rgba(0,0,0,0.05)",
                                transition: "all 0.2s ease-in-out",
                            },
                        }}
                    >
                        <IconButton
                            sx={{
                                color: "black",
                                fontSize: "clamp(1rem, 1rem, 1.25rem)",
                            }}
                        >
                            <PixOutlined sx={{ fontSize: "25px" }} />
                        </IconButton>
                        <Box display="flex" flexDirection="column" gap="0.5rem">
                            <Typography
                                fontWeight="bold"
                                fontSize="clamp(1rem, 1rem, 1.25rem)"
                                color="white"
                            >
                                Art, Sciences & Trivia
                            </Typography>
                            <Typography
                                fontSize="clamp(0.8rem, 0.9rem, 1rem)"
                                color="#484a4c"
                            >
                                Anatomy, Biology, Chemistry, Geography, History, Law, Math, Music, Pathology, Physics, and more!
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box m="2rem 0" />
            </Box>
            <Box
                flexBasis={isNonMobileScreens ? "40%" : undefined}
                mt={isNonMobileScreens ? undefined : "2rem"}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    gap="1rem"
                    justifyContent="center"
                    height="100%"
                    sx={{
                        "& > *": {
                            cursor: "pointer",
                        },
                    }}
                >
                    <img
                        width="90%"
                        height="auto"
                        style={{
                            objectFit: "cover",
                            borderRadius: "1rem",
                            margin: "0 auto",
                        }}
                        src={top_pcguy}
                        alt="pc guy"
                    />

                </Box>
            </Box>
        </Box>
    );
};

export default Top;
